module.exports = __webpack_public_path__ + "img/xu.6c68e97c.jpg";